import { utcToZonedTime } from 'date-fns-tz'
import { getDiscountSymbol } from '../../../../helper'
import { getActualItemsUnpaidOrder } from '../../../../helper/unpaidOrder'
import { COUPON_TYPES } from '../constants'
import { getTimeZoneByCountryCode } from '../../../../helper/getTimeZone'

export const sortItemsByLastCoupon = (a, b) => {
	if (COUPON_TYPES.includes(a.type)) return 1
	if (COUPON_TYPES.includes(b.type)) return -1
	return 0
}

export const convert2CouponResultItem = (item, currencySymbol) => {
	const { initialProduct, quantity, type } = item
	const discountSymbol = getDiscountSymbol(initialProduct?.discountData.discountType, currencySymbol)
	return ({
		initialProduct,
		itemId: initialProduct?.id,
		type,
		quantity,
		name: initialProduct?.name
			? initialProduct?.name + ' ' + initialProduct?.discountData.discount + discountSymbol
			: '',
		discountData: initialProduct?.discountData,
		status: initialProduct?.status,
	})
}

export const convert2ResultItems = (items, currencySymbol) => {
	const resultItems = items.reduce((acc, item) => {
		if (item.type === 'MARKETING_COUPON') {
			const couponItem = convert2CouponResultItem(item, currencySymbol)
			return [...acc, couponItem]
		}
		return [...acc, item]
	}, [])

	return resultItems.sort(sortItemsByLastCoupon)
}

export const convertToClientMonitorPurchaseItems = (resultItems, discountValue, discountType, discount, extraDiscountValue, extraDiscountType, extraDiscount, deliveryCost, couponPrice) => {
	const filteredItems = getActualItemsUnpaidOrder(resultItems, couponPrice)
	const discountItem = { name: 'Discount', type: 'DISCOUNT', quantity: 1, price: -discount, discountMetaData: { value: discountValue, type: discountType } }
	const extraDiscountItem = { name: 'Extra Rabatt', type: 'EXTRA_DISCOUNT', quantity: 1, price: -extraDiscount, discountMetaData: { value: extraDiscountValue, type: extraDiscountType } }
	const deliveryCostItem = { name: 'Delivery cost', type: 'DELIVERY_COST', quantity: 1, price: deliveryCost }
	return [...filteredItems, discountItem, extraDiscountItem, deliveryCostItem]
}

export const getExtraDiscountPrice = (items) => {
	const extraDiscountPrices = items.filter(item => item.type === 'EXTRA_DISCOUNT' && item.status !== 'CANCELED')?.[0]?.price
	return extraDiscountPrices || 0
}

export const getCategoryDiscountIsActive = (configs, item, companyCountryCode, orderType) => {
	const DAY_MAP = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY']

	const isMenu = item?.type === 'MENU'
	const all = Array.isArray(configs) ? configs : configs ? [configs] : []
	const list = orderType ? all.filter((c) => c?.businessScope === orderType) : all
	const config = isMenu
		? list[0]
		: list.find((c) => c?.priceDescriptions?.some((pd) => pd.id === item?.priceTitleId))
	if (!config) return null
	const companyTimeZone = getTimeZoneByCountryCode(companyCountryCode) || 'Europe/Berlin'
	const now = utcToZonedTime(new Date(), companyTimeZone)
	const currentDay = DAY_MAP[now.getDay()]

	const todayConfig = config?.days.find((d) => d.day === currentDay)
	if (!todayConfig || !todayConfig.enabled) return null

	const currentTime = now.toTimeString().slice(0, 5)
	const startTime = todayConfig.startTime?.slice(0, 5)
	const endTime = todayConfig.endTime?.slice(0, 5)

	if (startTime && endTime) {
		const isInTime = currentTime >= startTime && currentTime <= endTime
		if (!isInTime) return null
	}

	if (!(config?.discount?.value > 0)) return null

	return {
		...config?.discount,
		enabledWithOtherDiscounts: config?.enabledWithOtherDiscounts
	}
}

export const applyCategoryDiscounts = (items, configs, { orderType, companyCountryCode, module }) => {
	return items.map(item => {
		const categoryId = item?.categoryId ?? item?.initialProduct?.category?.id
		if (!categoryId) return item
		const discountInfo = getCategoryDiscountIsActive(configs[`${module}:${categoryId}`], { ...item, categoryId }, companyCountryCode, orderType)
		return { ...item, discountInfo }
	})
}
